import { render, staticRenderFns } from "./app-nav.vue?vue&type=template&id=23e0b54b&scoped=true&"
import script from "./app-nav.vue?vue&type=script&lang=js&"
export * from "./app-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0b54b",
  null
  
)

export default component.exports